import { render, staticRenderFns } from "./TrainingEdit.vue?vue&type=template&id=608f3f58"
import script from "./TrainingEdit.vue?vue&type=script&lang=js"
export * from "./TrainingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports